/*
  HW-CUSTOM START: Varianten-Picker – Auto-Auswahl + numerische Sortierung – 10/2026
 
  1) Sortierung (neu, 10/2026)
     Problem: Shopify legt die Reihenfolge der Optionswerte selbst fest (nach erstem
     Auftreten in der Variantenliste). Bei vielen Längen stehen die Pillen pro Breite
     dadurch durcheinander (z. B. Vakuumbeutel 250 mm: 300 · 280 · 350 …).
     Lösung: Die Pillen jeder Optionsgruppe werden nach ihrem Zahlenwert sortiert
     ("80 mm" < "100 mm", "1.000 Stk." < "Karton 8.000 Stk.").
     Gruppen, in denen nicht jeder Wert eine Zahl enthält (z. B. Farbe), bleiben unverändert.
 
  2) Auto-Auswahl (seit 21.10.2026)
     Problem: Wechselt der Kunde z. B. die Breite und die bisher gewählte Länge/Inhalt
     gibt es dazu nicht, bleibt Dawn auf der nicht existierenden Kombination stehen.
     Lösung: Nach jedem Neu-Rendern wird die erste Optionsgruppe (von oben) gesucht,
     deren gewählter Wert nicht verfügbar ist, und dort der erste verfügbare Wert
     (in sortierter Reihenfolge) ausgewählt. Dawn rendert danach neu -> die nächste
     Gruppe wird im nächsten Durchlauf korrigiert.
 
  Gilt nur für den Picker-Typ "Pillen" (Buttons).
  Bei einem Dawn-Update prüfen, ob ProductInfo.prototype.updateOptionValues noch existiert.
*/
(function () {
  /* ---------- Sortierung ---------- */
 
  // "1.000 Stk." -> 1000 · "Karton 8.000 Stk." -> 8000 · "80 mm" -> 80 · "0,5 mm" -> 0.5
  function hwNumber(text) {
    var cleaned = String(text).replace(/(\d)\.(?=\d{3}(\D|$))/g, '$1').replace(',', '.');
    var match = cleaned.match(/\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  }
 
  function hwSortFieldset(fieldset) {
    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    if (inputs.length < 2) return;
 
    var pairs = [];
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') return; // unbekannte Struktur -> nichts tun
      var num = hwNumber(input.value);
      if (num === null) return; // nicht jeder Wert numerisch -> Reihenfolge behalten
      pairs.push({ input: input, label: label, num: num, index: i });
    }
 
    pairs.sort(function (a, b) {
      return a.num - b.num || a.index - b.index;
    });
 
    // Paare (Input + Label) in sortierter Reihenfolge ans Ende des Fieldsets hängen
    pairs.forEach(function (p) {
      fieldset.appendChild(p.input);
      fieldset.appendChild(p.label);
    });
  }
 
  function hwSortPills(root) {
    if (!root) return;
    var fieldsets = root.querySelectorAll('variant-selects fieldset.product-form__input--pill');
    for (var i = 0; i < fieldsets.length; i++) hwSortFieldset(fieldsets[i]);
  }
 
  // Beim ersten Laden der Seite
  hwSortPills(document);
 
  /* ---------- Hook in Dawns Neu-Rendern ---------- */
 
  customElements.whenDefined('product-info').then(function () {
    var ProductInfo = customElements.get('product-info');
    if (!ProductInfo || ProductInfo.prototype.hwAutoSelectPatched) return;
    ProductInfo.prototype.hwAutoSelectPatched = true;
 
    var originalUpdateOptionValues = ProductInfo.prototype.updateOptionValues;
    ProductInfo.prototype.updateOptionValues = function (html) {
      hwSortPills(html); // neues HTML vor dem Einsetzen sortieren -> kein Springen
      originalUpdateOptionValues.call(this, html);
      var productInfo = this;
      setTimeout(function () {
        hwSortPills(productInfo); // Sicherheitsnetz, falls Dawn das HTML anders einsetzt
        hwFixUnavailableSelection(productInfo);
      }, 0);
    };
  });
 
  /* ---------- Auto-Auswahl ---------- */
 
  function hwFixUnavailableSelection(productInfo) {
    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return;
 
    var fieldsets = variantSelects.querySelectorAll('fieldset.product-form__input--pill');
    for (var i = 0; i < fieldsets.length; i++) {
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (!checked || !checked.classList.contains('disabled')) continue;
 
      var firstAvailable = fieldsets[i].querySelector('input[type="radio"]:not(.disabled)');
      if (!firstAvailable) return;
 
      firstAvailable.checked = true;
      firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
      return; // weitere Gruppen werden nach dem nächsten Neu-Rendern geprüft
    }
  }
})();
/* HW-CUSTOM END */